import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Link,
  TextField,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { Stack } from '@mui/system';
import * as RouterPath from '../data/RouterPath';
import axios from 'axios';
import { baseURL, headers as baseHeaders } from '../data/Config';
import { useLanguageStore } from '../store/useLanguageStore';
import { useRegionStore } from '../store/useRegionStore';
import { useEffect, useMemo, useState } from 'react';
import { switchRegionBaseUrl } from '../utils/httpUtils';
import useTokens from '../hooks/useTokens';
import useBaseUrl from '../hooks/useBaseUrl';
import { getCookie, setCookie } from '../utils/cookie';

function TokensNew() {
  const navigate = useNavigate();
  const [tokenName, setTokenName] = useState('');
  const onChangeTokenName = (e) => setTokenName(e.target.value);
  // const [baseUrl, setBaseUrl] = useState(baseURL);
  const bearerToken = getCookie('bearer_token');
  const { languagePack } = useLanguageStore();
  const { region } = useRegionStore();
  const baseUrl = useBaseUrl(region);
  const { pats, tokenState, setTokenState } = useTokens(
    baseUrl as string,
    false,
    bearerToken
  );
  const accessToken = getCookie('bearer_token');
  const requestHeaders = useMemo(
    () => ({
      ...baseHeaders,
      Authorization: `Bearer ${accessToken}`,
    }),
    [accessToken]
  );

  const [checked, setChecked] = React.useState({
    allDeviceInquiry: false,
    allDeviceStateInquiry: false,
    allDeviceControl: false,
    allDeviceEventSubscription: false,
    allDevicePushSubscription: false,
    allDeviceEnergy: false,
  });

  const onPermissionCheckClick = (name: string) => {
    setChecked((prevChecked) => ({
      ...prevChecked,
      [name]: !prevChecked[name],
    }));
  };

  const selectAllPermissions = () => {
    setChecked({
      allDeviceInquiry: true,
      allDeviceStateInquiry: true,
      allDeviceControl: true,
      allDeviceEventSubscription: true,
      allDevicePushSubscription: true,
      allDeviceEnergy: true,
    });
  };

  const deselectAllPermissions = () => {
    setChecked({
      allDeviceInquiry: false,
      allDeviceStateInquiry: false,
      allDeviceControl: false,
      allDeviceEventSubscription: false,
      allDevicePushSubscription: false,
      allDeviceEnergy: false,
    });
  };

  const scopeMapping = {
    allDeviceInquiry: 'THINQ_DEVICE_LIST',
    allDeviceStateInquiry: 'THINQ_DEVICE_STATUS',
    allDeviceControl: 'THINQ_DEVICE_CONTROL',
    allDeviceEventSubscription: 'THINQ_DEVICE_EVENT',
    allDevicePushSubscription: 'THINQ_DEVICE_PUSH',
    allDeviceEnergy: 'THINQ_DEVICE_ENERGY',
  };

  const createToken = () => {
    if (tokenName.trim() === '') {
      alert(languagePack && languagePack.tokenNew.tokenNameAlert);
      return;
    }

    const scopes = Object.entries(checked)
      .filter(([, value]) => value)
      .map(([key]) => scopeMapping[key]);

    const payload = {
      name: tokenName,
      scopes,
    };

    axios
      .post(`${baseUrl}/pat`, payload, { headers: requestHeaders })
      .then((res) => {
        setTokenState('created');
        navigate(RouterPath.TOKENS);
      })
      .catch((e) => {
        setTokenState('failed');
        navigate(RouterPath.TOKENS);
      });
  };

  // const createToken = () => {
  //   const payload = {
  //     name: tokenName,
  //     scopes: [
  //       'THINQ_DEVICE_LIST',
  //       'THINQ_DEVICE_CONTROL',
  //       'THINQ_DEVICE_STATUS',
  //       'THINQ_DEVICE_PUSH',
  //       'THINQ_DEVICE_EVENT',
  //     ],
  //   };
  //   axios
  //     .post(`${baseUrl}/pat`, payload, { headers })
  //     .then((res) => {
  //       setTokenState('created');
  //       navigate(RouterPath.TOKENS);
  //       // navigate(RouterPath.TOKENS, {
  //       //   state: {
  //       //     type: 'created',
  //       //     result: res.data.result.token,
  //       //   },
  //       // });
  //     })
  //     .catch((e) => {
  //       setTokenState('failed');
  //       navigate(RouterPath.TOKENS);
  //       // navigate(RouterPath.TOKENS, {
  //       //   state: {
  //       //     type: 'failed',
  //       //     status: e.response.status,
  //       //   },
  //       // });
  //     });
  // };

  // useEffect(() => {
  //   setBaseUrl(switchRegionBaseUrl(region));
  // }, [region]);

  return (
    <Box className="contents">
      <Box className="contents-header">
        <Typography className="title" variant="h3">
          {languagePack && languagePack.tokenNew.title}
        </Typography>
        <Stack direction="column" alignItems="flex-start" spacing={1}>
          <Typography className="desc" variant="body1" alignSelf="flex-start">
            {languagePack && languagePack.tokenNew.description1}
          </Typography>
          <Typography
            className="desc"
            variant="body1"
            sx={{
              alignSelf: 'flex-start',
              // display: 'flex',
              // flexDirection: 'row',
            }}
          >
            {languagePack && languagePack.tokenNew.description2}
            &nbsp;
            <a
              className="desc"
              href={languagePack && languagePack.tokenNew.developsite}
              target="_blank"
              rel="noopener noreferrer"
            >
              {languagePack && languagePack.tokenNew.description3}
            </a>
            &nbsp;
            {languagePack && languagePack.tokenNew.description4}
          </Typography>
          {/* <Button variant="contained" color="primary" size="large">새 토큰 만들기</Button> */}
        </Stack>
      </Box>

      <Paper elevation={2} className="contents-form">
        <Stack direction="row" justifyContent="flex-end">
          <Typography variant="caption" className="required">
            * Required Field
          </Typography>
        </Stack>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography className="title" variant="h4">
            {languagePack && languagePack.tokenNew.tokenName}
            <span className="required">*</span>
          </Typography>
          <TextField
            hiddenLabel
            id="filled-hidden-label-normal"
            variant="outlined"
            placeholder={
              languagePack && languagePack.tokenNew.tokenNamePlaceholder
            }
            value={tokenName}
            onChange={onChangeTokenName}
            required
          />
          <Stack direction="row" className="title-wrap">
            <Typography className="title" variant="h4">
              {languagePack && languagePack.tokenNew.permissionScope}
              <span className="required">*</span>
            </Typography>
            <Stack spacing={1} direction="row">
              <Button
                variant="contained"
                color="inherit"
                onClick={deselectAllPermissions}
              >
                {languagePack && languagePack.tokenNew.deselectAll}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={selectAllPermissions}
              >
                {languagePack && languagePack.tokenNew.selectAll}
              </Button>
            </Stack>
          </Stack>
          <Box className="contents-form-checkbox">
            <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDeviceInquiryPermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDeviceInquiry}
                    onChange={() => onPermissionCheckClick('allDeviceInquiry')}
                  />
                }
              />
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDeviceStateInquiryPermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDeviceStateInquiry}
                    onChange={() =>
                      onPermissionCheckClick('allDeviceStateInquiry')
                    }
                  />
                }
              />
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDeviceControlPermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDeviceControl}
                    onChange={() => onPermissionCheckClick('allDeviceControl')}
                  />
                }
              />
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDeviceEventSubscribePermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDeviceEventSubscription}
                    onChange={() =>
                      onPermissionCheckClick('allDeviceEventSubscription')
                    }
                  />
                }
              />
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDevicePushSubscribePermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDevicePushSubscription}
                    onChange={() =>
                      onPermissionCheckClick('allDevicePushSubscription')
                    }
                  />
                }
              />
              <FormControlLabel
                label={
                  languagePack &&
                  languagePack.tokenNew.allDeviceEnergyPermission
                }
                control={
                  <Checkbox
                    defaultChecked={false}
                    checked={checked.allDeviceEnergy}
                    onChange={() => onPermissionCheckClick('allDeviceEnergy')}
                  />
                }
              />
            </Box>
          </Box>
        </Box>
      </Paper>
      <Stack
        sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 1 }}
        spacing={1}
        direction="row"
      >
        <Button
          variant="contained"
          color="inherit"
          onClick={() => {
            navigate(RouterPath.TOKENS);
          }}
        >
          {languagePack && languagePack.tokenNew.btnCancel}
        </Button>
        <Button variant="contained" color="primary" onClick={createToken}>
          {languagePack && languagePack.tokenNew.createTokenBtn}
        </Button>
      </Stack>
    </Box>
  );
}

export default TokensNew;
